import { AVATAR_SVG_DATA } from '../../lib/avatarSvgData';
import { BaseSvg } from './BaseSvg';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  name,
  svgSize,
  paths
} = AVATAR_SVG_DATA.CONTACT;
export const ContactSvg = () => {
  return /*#__PURE__*/_jsx(BaseSvg, {
    name: name,
    size: svgSize,
    children: paths.map(d => /*#__PURE__*/_jsx("path", {
      d: d
    }, d))
  });
};